import { render, staticRenderFns } from "./VariantsListing.vue?vue&type=template&id=56d23496&scoped=true&"
import script from "./VariantsListing.vue?vue&type=script&lang=js&"
export * from "./VariantsListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d23496",
  null
  
)

export default component.exports